import React from 'react';
import ProductSuggestionSwiper from './product-suggestion-swiper';
import {useTranslation} from 'next-i18next';

const ProductsSuggestionBlock = () => {
    const {t} = useTranslation('common');

    return (
        <div className="mt-5 flex w-full justify-center bg-interested-products-category-page px-5 pb-2 pt-5">
            <div className="w-full px-5 lg:w-5xl xl:w-301">
                <h2 className="text-[1.375rem] font-extrabold text-primary">
                    {t('for-you-products', 'Sản phẩm dành riêng cho bạn')}
                </h2>
                <ProductSuggestionSwiper />
            </div>
        </div>
    );
};

export default ProductsSuggestionBlock;
